import axios from 'axios'
import snakecaseKeys from 'snakecase-keys'
import camelcaseKeys from 'camelcase-keys'

const VueAxiosPlugin = {}
export default VueAxiosPlugin.install = function (Vue, { store, router }) {
  axios.interceptors.request.use((request) => {
    // マルチテナント対応
    request.baseURL = `${window.location.origin}/`

    if (request.params) {
      const snakecaseParams = snakecaseKeys(request.params, {
        deep: true
      })
      request.params = snakecaseParams
    }

    if (request.data && !(request.data instanceof FormData)) {
      let snakecaseData
      snakecaseData = snakecaseKeys(request.data, {
        deep: true,
        exclude: ['_destroy']
      })

      request.data = snakecaseData
    }

    // jwtのトークンを入れる
    request.withCredentials = true

    return request
  })

  axios.interceptors.response.use(
    (response) => {
      if (!response.data || typeof response.data !== 'object') {
        return response
      }
      response.data = camelcaseKeys(response.data, { deep: true })
      return response
    },
    (error) => {
      if (error.response.status === 401) {
        const payload = {
          status: error.response.status,
          message: `認証に失敗しました。再度ログインしてください`
        }
        store.dispatch('SystemMessageStore/createMessage', payload)
        store
          .dispatch('UserAuthStore/logOut')
          .finally(() => {
            router.push({
              path: '/user_auths/sign_in',
              query: { redirect: router.currentRoute.fullPath }
            })
          }
          )
      }

      return Promise.reject(error)
    }
  )
}
